import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { SiteNotesService } from 'app/_services/site-notes.service';
import { SiteService } from 'app/_services/site.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-site-notes',
  templateUrl: './site-notes.component.html',
})
export class SiteNotesComponent implements OnInit {
  public selectedSite: any;
  private selectedSiteId: any;

  public siteNotes: any = [];

  public pageSizes: any = environment.pageSizes;
  public pagination: any;

  constructor(
    private siteService: SiteService,
    private siteNotesService: SiteNotesService,
    activatedRoute: ActivatedRoute,
  ) {
    activatedRoute.params.subscribe((params: Params) => {
      this.selectedSiteId = params.id;
    });

    this.resetPagination();
  }

  ngOnInit() {
    this.getSelectedSite(this.selectedSiteId);
    this.getAllSiteNotes();
  }

  private getSelectedSite(id) {
    this.siteService.getSiteById(id).subscribe((data: any) => {
      this.selectedSite = data;
    });
  }

  private getAllSiteNotes() {
    this.siteNotesService.getAllNotesBySiteId(this.selectedSiteId, this.pagination).subscribe((data: any) => {
      this.siteNotes = data.body;
      this.pagination.totalRecords = Number(data.headers.get('X-Total-Count'));
    });
  }

  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.getAllSiteNotes();
  }

  private resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };
    this.getAllSiteNotes();
  }
}
